function WizardItem({ children }) {
  return children;
}

export default WizardItem;
